module.exports = "/wp-content/plugins/farmacy/assets/js/images/banner_new_item-f0ce83ce1a87ce1b941207d1e22a7da7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/banner_new_item.png
 ** module id = 152
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/